import React, {
  useCallback,
  useMemo,
  useRef,
} from "react";
import { Typography } from "antd";
import _, { isEqual, isFunction } from "lodash";
import TableWithAddDeleteActionColumn from "components/TableWithAddDeleteActionColumn";
import { Sorters } from "utils/tableUtils";
import { checkHttpElsePrefixLink } from "utils/formUtils";
import ACLink from "ac-components/ACLink/ACLink";

export default function ArtifactsTable({ parentDataSourceRef, form, editable = false, source, permission , newUI = false, nameWidth = 200, linkWidth = 300, addButtonText, onArtifactChange, prefKey}) {
  const lastSentArtifactsRef = useRef([]);

  const onChange = useCallback(async (artifacts) => {
    const _artifacts = _.filter(artifacts, artifact => !_.isEmpty(artifact.link) && !_.isEmpty(artifact.name));
    const finalArtiFacts = _.map(_artifacts, artifact => _.pick(artifact, ["name", "link"])) 
    form.setFieldsValue({ artifacts: finalArtiFacts});

    if(newUI && isFunction(onArtifactChange) && !isEqual(lastSentArtifactsRef.current, finalArtiFacts)){
      lastSentArtifactsRef.current = finalArtiFacts
      onArtifactChange(finalArtiFacts)
    }
  }, [form, onArtifactChange, newUI]);

  const columns = useMemo(() => {
    return [
      {
        title: "Name",
        dataIndex: 'name',
        key: "name",
        width: nameWidth,
        ellipsis: true,
        required: true,
        sorter: Sorters.STRING('name'),
      },
      {
        title: "Link",
        dataIndex: 'link',
        key: "link",
        width: linkWidth,
        ellipsis: true,
        required: true,
        sorter: Sorters.STRING('link'),
        render: (link) => {
          if(newUI){
            return <ACLink href={checkHttpElsePrefixLink(link)} primary={false} overlay target="_blank">{link}</ACLink>
          }
          return <Typography.Link href={checkHttpElsePrefixLink(link)} target="_blank">{link}</Typography.Link>
        },
        validator: (_, value) => {
          // update validator for ENG-31953
          if(value) {
              if (value.startsWith('https://') || value.startsWith('http://')) {
                return Promise.resolve();
              } else {
                return Promise.reject(new Error('Should start with http:// or https://'));
              }
          }
            else {
              return Promise.resolve();
          }
        }
      }
    ]
  }, [nameWidth, linkWidth, newUI]);

  return <>
    <TableWithAddDeleteActionColumn
      parentForm={form}
      source={source}
      editable={editable}
      columns={columns}
      onChange={onChange}
      ref={parentDataSourceRef}
      showDescriptiontag={false}
      maxRows={100}
      permission={permission}
      newUI={newUI}
      addButtonText={addButtonText}
      prefKey={prefKey}
    />
  </>
}
